import type { LayerConfig, PixelType } from '../../type';
import { isPixelVisible, isUserContribution } from './logic';
import * as S from './style';

export interface TreePatternProps {
  pixels: PixelType[][];
  layerConfig: LayerConfig;
  layerIndex: number;
  fillCount: number;
  userContribution?: {
    startPixel: number;
    pixelCount: number;
  } | null;
}

export function TreePattern({
  pixels,
  layerConfig,
  fillCount,
  userContribution,
}: TreePatternProps) {
  return (
    <S.TreeLayerWrapper>
      {pixels.map((row, rowIndex) => (
        <S.Row key={`row-${rowIndex}`}>
          {row.map((pixel, colIndex) => (
            <S.Pixel
              key={`pixel-${rowIndex}-${colIndex}`}
              id={`${rowIndex}-${colIndex}`}
              type={pixel}
              layerConfig={layerConfig}
              isVisible={isPixelVisible(rowIndex, colIndex, pixels, fillCount)}
              isUserContribution={isUserContribution(
                rowIndex,
                colIndex,
                pixels,
                userContribution,
              )}
            />
          ))}
        </S.Row>
      ))}
    </S.TreeLayerWrapper>
  );
}
